var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM4 5.33333C3.63181 5.33333 3.33333 5.63181 3.33333 6C3.33333 6.36819 3.63181 6.66667 4 6.66667H8C8.36819 6.66667 8.66667 6.36819 8.66667 6C8.66667 5.63181 8.36819 5.33333 8 5.33333H4Z",
    fill: "#F3F7FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTest);
export default __webpack_public_path__ + "static/media/add-test.3a1a8f4717ed18e4612071b0b40acac5.svg";
export { ForwardRef as ReactComponent };